import $ from 'zepto-webpack';
import QRCode from 'qrcodejs2'
import './scss/download.scss';
$(document).ready(function () {
    $("#mobile").on("click", function () {
        $("body").height("100%").css("overflow", "hidden");
        $(".cover").show();
        $(".ios-panel").show();
    });
    new QRCode('andCode', {
        text:window.v_ard,
        type: 'image/jpeg',
        width: 120,
        height: 120,
        correctLevel : QRCode.CorrectLevel.H
    });
    new QRCode('iosCodePC', {
        text:window.v_ios,
        type: 'image/jpeg',
        width: 120,
        height: 120,
        correctLevel : QRCode.CorrectLevel.H
    });
    new QRCode('iosCodeM', {
        text:window.location.href,
        type: 'image/jpeg',
        width: 120,
        height: 120,
        correctLevel : QRCode.CorrectLevel.H
    });
    $(".hide").on("click", function () {
        $("body").height("auto").css("overflow", "auto");
        $(".cover").hide();
        $(".ios-panel").hide();
    });
    $('.version_and').text(window.v_ard);
    $('.version_ios').text(window.v_ios);
    $('.load_and').attr('href',window.link_ard);
    $('.load_ios').attr('href',window.link_ios);
    var html='';
    window.link_tf.map(item=>{
        html+=' <li class="item">'+
        '<a href="'+item+'" target="_blank">下载地址1</a>'+
        '</li>'
    })
    $('.load_tf').html(html);
})